import { createSlotRecipe } from './runtime';

const splitterConfig = {"name":"splitter","slots":["root","panel","resizeTrigger"]}

export const splitter = /* @__PURE__ */ createSlotRecipe(splitterConfig)